(function ($) {
  Drupal.behaviors.siwertellEuCookieCompliance = {
    attach: function () {
      setTimeout(function () {
        const $cookieBanner = $("#eu-cookie-compliance-banner");

        // Check if cookie banner is visible
        if ($cookieBanner) {
          const $cookieMessageText = $("#popup-text");
          const $editSettingsBtn = $("#eu-cookie-edit-settings-button");
          const $cookieCategoriesBtns = $(
            "#eu-cookie-compliance-categories-buttons"
          );
          const $cookieCategories = $("#eu-cookie-compliance-categories");
          const $cookieDescChevron = $(
            ".eu-cookie-compliance-category-chevron-wrapper"
          );
          const $allCloseChevrons = $(
            ".eu-cookie-compliance-category-chevron--close"
          );
          const $allOpenChevrons = $(
            ".eu-cookie-compliance-category-chevron--open"
          );

          const $cookieCategoryDescriptions = $(
            ".eu-cookie-compliance-category-description"
          );

          const $elementsToShow = [
            "#eu-cookie-compliance-settings-header",
            "#eu-cookie-edit-settings-buttons",
          ];

          // when clicking edit settings button hide and show following elements
          $editSettingsBtn.on("click", () => {
            $elementsToShow.forEach((el) => {
              $(el).show();
            });
            $cookieCategories.css("display", "flex");
            $cookieCategoriesBtns.css("display", "flex");
            $cookieMessageText.hide();
            $editSettingsBtn.hide();
          });

          // when clicking a description chevron open description
          $cookieDescChevron.click(function (event) {
            const $chevronChildren = $(event.currentTarget).children();
            const $chevronOpen = $($chevronChildren[0]);
            const $chevronClose = $($chevronChildren[1]);
            let $descToOpenId = $(event.currentTarget).attr("id");
            let $targetDescription;

            $descToOpenId = $descToOpenId.slice(5);

            $targetDescription = $(
              `#eu-cookie-compliance-category-description-${$descToOpenId}`
            );

            $cookieCategoryDescriptions.fadeOut(1);
            $allCloseChevrons.hide();
            $allOpenChevrons.show();

            if ($targetDescription.is(":visible")) {
              $chevronClose.hide();
              $chevronOpen.show();
            } else {
              $targetDescription.fadeIn("fast");
              $chevronClose.show();
              $chevronOpen.hide();
            }
          });
        }
      }, 200);
    },
  };
})(jQuery);
